import axios from 'axios';

import { apiConfig } from '@constants';

import { getDspAuthHeader } from '../../../helpers/DspAuth';

export const sendBookmark = async (time, id, seasonID) => {
  const headers = await getDspAuthHeader();

  if (headers) {
    const bookmarkURL = `${apiConfig.DSP_SEND_BOOKMARK_URL}/${id}/${time}${seasonID ? `?channel_id=${seasonID}` : ''}`;

    await axios.post(bookmarkURL, null, { headers });
  }
};
